import { useRef } from 'react';
import { Button } from '../../components/ui/button';
import { Camera, Image as ImageIcon, Paperclip } from 'lucide-react';

const FILE_ACCEPT = '.stl,.ply,.obj,.zip,.pdf,.jpg,.jpeg,.png,.xlsx,.xls,.csv';

export const UploadButtons = ({ onFiles, disabled, compact }) => {
  const cameraRef = useRef(null);
  const galleryRef = useRef(null);
  const fileRef = useRef(null);

  const handle = (e) => {
    if (e.target.files?.length) onFiles(e.target.files);
    e.target.value = '';
  };

  return (
    <div className={`flex gap-2 ${compact ? 'flex-nowrap shrink-0' : 'flex-wrap'}`}>
      <input ref={cameraRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={handle} data-testid="upload-camera-input" />
      <input ref={galleryRef} type="file" accept="image/*" multiple className="hidden" onChange={handle} data-testid="upload-gallery-input" />
      <input ref={fileRef} type="file" accept={FILE_ACCEPT} multiple className="hidden" onChange={handle} data-testid="upload-file-input" />
      <Button type="button" variant="outline" size={compact ? 'sm' : 'default'} className="gap-2" disabled={disabled}
        onClick={() => cameraRef.current?.click()} data-testid="upload-camera-btn">
        <Camera className="h-4 w-4" />{!compact && 'Prendre une photo'}
      </Button>
      <Button type="button" variant="outline" size={compact ? 'sm' : 'default'} className="gap-2" disabled={disabled}
        onClick={() => galleryRef.current?.click()} data-testid="upload-gallery-btn">
        <ImageIcon className="h-4 w-4" />{!compact && 'Galerie'}
      </Button>
      <Button type="button" variant="outline" size={compact ? 'sm' : 'default'} className="gap-2" disabled={disabled}
        onClick={() => fileRef.current?.click()} data-testid="upload-files-btn">
        <Paperclip className="h-4 w-4" />{!compact && 'Fichier'}
      </Button>
    </div>
  );
};
